import './damico/style';
import FormStructure from './damico/form_structure';

export default FormStructure;